import { inject, observer } from 'mobx-react';
import React from 'react';

import { Button, Dialog, LinearProgress, TextField } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import API from 'app/API';

import Captcha from './../utils/Captcha.jsx';

const recaptchaRef = React.createRef();

@inject('userStore')
@inject('dialogStore')
@observer
export default class Login extends React.Component {
    state = {
        email: '',
        errorText: '',
        loading: false
    };

    handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

    onRecovery = () => {
        this.setState({ loading: true });
        API.fetchWithToken(API.SEND_RECOVERY, {
            email: this.state.email,
            captcha: recaptchaRef.current.getValue()
        }).then((response) => {
            this.setState({
                loading: false,
                errorText: response.result === 'error' ? response.data.error : ''
            });

            if (response.result === 'OK') {
                this.props.dialogStore.openMessageDialog(
                    'Recover your access',
                    'Message with access recovery link was sent to your email'
                );
            }
        });
    };

    render() {
        const { openLoginDialog, recoveryDialogOpen } = this.props.dialogStore;

        return (
            <Dialog maxWidth="xs" open={recoveryDialogOpen} onClose={openLoginDialog} className="vulners-dialog">
                <DialogTitle>Recover password</DialogTitle>
                <DialogContent>
                    <TextField fullWidth name="email" label="Email" onChange={this.handleChange} />

                    <br />

                    <Captcha id="vulners-login-captcha" ref={recaptchaRef} action="recover-password" />

                    <div className="vulners-dialog-error-text">{this.state.errorText}</div>

                    {this.state.loading && <LinearProgress mode="indeterminate" />}

                    <Button
                        fullWidth
                        color="primary"
                        variant="contained"
                        onClick={this.onRecovery}
                        disabled={this.state.loading}
                    >
                        SEND
                    </Button>

                    <br />
                    <br />
                </DialogContent>
            </Dialog>
        );
    }
}
